/* eslint-disable */
import React from 'react';
import Home from '../../content/Home';
import HomeCard from './HomeCard';
import styles from "../../assets/css/modules/carousel/home-carousel.css";
import { connect } from "react-redux";
import MemberHelper from "../../helpers/MemberHelper";
import { shouldShowIfAllSMEModulesDontMatch,shouldShowIfAnySMEModulesMatch } from "../../helpers/SMEModules/smeModuleHelper";
import { EAPEssential, EAPPremier } from "../../constants/SMEModules";
import DateHelper from "../../helpers/DateHelper";
import { nonClaimsModules } from "../../constants/SMEModulesToMatchOn";
// import navigationRight from "../../assets/img/carousel/navigate_next.png";
// import navigateLeft from "../../assets/img/carousel/navigate_before.png";
import { Layouts } from '../../constants/Constants';
import {    
    setCarouselCount ,
     setTotalCount 
  } from "../../actions/policy/policyActions";
  const mapDispatchToProps = (dispatch) => {
    return {setCarouselCount: (slideCount) => dispatch(setCarouselCount(slideCount)),
        setTotalCount : (totCount) => dispatch(setTotalCount(totCount))
    }
}
export const mapStateToHomeCarousel = ({policyReducer ={},layoutReducer={} ,carouselReducer={}}) => {
    const currentPolicy = policyReducer.selectedPolicy;
    const carouselCount =carouselReducer.carouselCount;
    const isInternationalOrSaga =
        currentPolicy && (currentPolicy.IsSaga || currentPolicy.IsInternational);
    const isLapsed = currentPolicy && currentPolicy.IsLapsed;
    const isChildOnly = currentPolicy?.IsChildOnlyPolicy;
    const IsSaga = currentPolicy && currentPolicy.IsSaga;
    const IsSME = currentPolicy && currentPolicy.IsSME;
    const selectedPolicy = policyReducer && policyReducer.selectedPolicy;
      const currentMember = MemberHelper.getCurrentLoggedInMemberFromPolicy(
        selectedPolicy
      );
    return {
        isLapsed,
        isInternationalOrSaga,
        IsSaga,
        carouselCount,
        IsSME,
        layout: layoutReducer && layoutReducer.layout,
        isSMEModular: currentPolicy && currentPolicy.IsSMEModular,
        isLargeCorporate: currentPolicy && currentPolicy.IsLargeCorporate,
        isEDCA: currentPolicy && currentPolicy.IsEDCA,
        isIndividual: currentPolicy && currentPolicy.IsIndividual,
        isChildOnly: isChildOnly,
        DateOfBirth: DateHelper.getDateInStringFormat(currentMember.DateOfBirth),
        isAgeAbove18:DateHelper.isAgeAbove18(currentMember.DateOfBirth),
        shouldShowClaims: shouldShowIfAllSMEModulesDontMatch(
            policyReducer && policyReducer.selectedPolicy,
            nonClaimsModules
        ),
        EAPPremier: shouldShowIfAnySMEModulesMatch(currentPolicy && currentPolicy, [EAPPremier]),
        EAPEssential: shouldShowIfAnySMEModulesMatch(currentPolicy && currentPolicy, [EAPEssential]),
    };
    
};
 

export class HomeCarousel extends React.Component {
    
    state = {
        currentSlideIndex: 0,
        // carouselDescription1:'Discover what other member benefits',
        // carouselDescription2:'  and offers you have access to.',
        carouselWindowUpdate:false,
    }
    componentDidMount(){
        window.addEventListener("resize",this.resize.bind(this));
        this.resize();
    }
    resize(){
        if(window.innerWidth > 768){
                    this.setState({carouselWindowUpdate:true});
                }else{
                    this.setState({carouselWindowUpdate:false});
                }
    }
    componentWillUnmount(){
        window.removeEventListener("resize",this.resize.bind(this));
    }
    // componentDidUpdate(){
    //     if(window.innerWidth < 768){
    //         this.setState({carouselWindowUpdate:true});
    //     }else{
    //         this.setState({carouselWindowUpdate:false});
    //     }
    // }
    render() {
        // let EapView;
        // if(this.props.shouldShowClaims ) {
        //     if(window.innerWidth > 768){
        //         EapView =Home.EAPCarousel ; 
        //     }
        //     else{
        //         EapView=Home.EAPMOBCarousel ;
        //     }

        // }
        let IndividualView;
        if(this.props.layout === Layouts.MOL){
        if(this.props.isIndividual){
            // if(window.innerWidth > 768){
                IndividualView = Home.IndividualCarousel;
            // }
            // else{
            //     IndividualView = Home.IndividualMOBCarousel;
            // }
        }} else{
        if(this.props.isIndividual){
            // if(window.innerWidth > 768){
                IndividualView = Home.HOlIndividualCarousel;
            // }
            // else{
            //     IndividualView = Home.HOlIndividualMOBCarousel;
            // } 
        }
        }
        // let SagaView;
        // if(this.props.IsSaga){
        //     if(window.innerWidth > 768){
        //         SagaView = Home.SagaCarousel;
        //     }
        //     else{
        //         SagaView = Home.SagaMOBCarousel;
        //     }
        // }
 
        const values = this.props.IsSaga ? Home.SagaCarousel :
            this.props.isIndividual ? IndividualView :
                    this.props.isLargeCorporate ? Home.LargeCorporateCarousel :
                    this.props.IsSME && !(this.props.EAPEssential || this.props.EAPPremier) ? Home.SMECarousel : (this.props.EAPEssential || this.props.EAPPremier) ? Home.EAPCarousel : Home.SMECarousel;
        let result = Object.entries(values);
        // const totalSlides = Math.ceil(result.length / 3);
        const totalSlides = (this.props.isAgeAbove18 ? (window.innerWidth > 768 ?   result.length: result.length): result.length - 1);
        this.props.setTotalCount(totalSlides);
        const getImagesForSlide = (slideIndex) => {
            let indexVal = null;
            for (var i=0;i<result.length;i++)
            {
                if(result[i].includes("musclebonejoint"))
                {
                    indexVal = i;
                    break;
                } 
            }
            if(!this.props.isAgeAbove18 && indexVal != null)
            {
                result.splice(indexVal,1);
            }
            const startIndex = slideIndex * 1;
            return  result.slice(startIndex, startIndex + 3);
  };
        // const getImageForDevices = (slideIndex) => {
        //     const startIndex = slideIndex * 1;
        //     return result.slice(startIndex, startIndex + 1);
        // };
        // const handleDotClick = (index) => {
        //     this.setState({ currentSlideIndex: index });
        // };
        // const prevSlide = () => {
        //     // const { currentSlideIndex } = this.props.carouselCount;
        //     const newSlide = this.props.carouselCount > 0 ?this.props.carouselCount - 1 : totalSlides - 1;
        //     // this.setState({ currentSlideIndex: newSlide });
        //     this.props.setCarouselCount(newSlide);
        // };
        // const nextSlide = () => {
        //     // const { currentSlideIndex } = this.props.carouselCount;
        //     const newSlide = this.props.carouselCount < totalSlides - 1 ? this.props.carouselCount + 1 : 0;
        //     // this.setState({ currentSlideIndex: newSlide });
        //     this.props.setCarouselCount(newSlide);
        // };
        return (

            <div>
                <h3 className={styles.heading}>More from your membership</h3>
                <p className={styles.description}>
                {/* {window.innerWidth > 768 ?'Discover what other member benefits and offers you have access to.':
              <><div>{this.state.carouselDescription1}</div><div>{this.state.carouselDescription2}
              </div></> } */}
              Discover what other member benefits and offers you have access to.</p>
                <div className={styles.cardContent}>

                     {/* <img
                        src={navigateLeft}
                        alt="navigation arrow"
                        onClick={prevSlide}
                        className={this.props.carouselCount === 0 ? styles.prevSlide : styles.prevSlideActive}
                    />  */}

                    <div className={styles.cards}>
                    {/* window.innerWidth > 768 ? getImagesForSlide(this.state.currentSlideIndex).map((carousel, index) =>  */}
                        {window.innerWidth > 992 ? getImagesForSlide(this.props.carouselCount).map((carousel, index) => 
                        this.props.isAgeAbove18 && !this.props.isLapsed ? (                         
                                        
                            <HomeCard key={index}
                                IconSrc={carousel[1].IconSrc.Any}
                                Heading={carousel[1].Heading}
                                Description={carousel[1].Description}
                                LinkText={carousel[1].LinkText}
                                LinkTo={carousel[1].LinkTo}
                                ExternalLinkTo={carousel[1].ExternalLinkTo}
                                carouselData="carouselDatas"
                                id={carousel[1].id}
                            />
                        ): carousel[0]!="musclebonejoint" && (
                            <HomeCard key={index}
                                IconSrc={carousel[1].IconSrc.Any}
                                Heading={carousel[1].Heading}
                                Description={carousel[1].Description}
                                LinkText={carousel[1].LinkText}
                                LinkTo={carousel[1].LinkTo}
                                ExternalLinkTo={carousel[1].ExternalLinkTo}
                                carouselData="carouselDatas"
                                id={carousel[1].id}
                            />
                        ))                      
                        : result.map((carousel,index) => 
                        this.props.isAgeAbove18 && !this.props.isLapsed? (
                            <HomeCard key={index}
                            IconSrc={carousel[1].IconSrc.Any}
                            Heading={carousel[1].Heading}
                            Description={carousel[1].Description}
                            LinkText={carousel[1].LinkText}
                            LinkTo={carousel[1].LinkTo}
                            ExternalLinkTo={carousel[1].ExternalLinkTo}
                            carouselData="carouselDatas"
                            id={carousel[1].id}
                        />  
                        ): carousel[0]!="musclebonejoint" && (
                            <HomeCard key={index}
                                IconSrc={carousel[1].IconSrc.Any}
                                Heading={carousel[1].Heading}
                                Description={carousel[1].Description}
                                LinkText={carousel[1].LinkText}
                                LinkTo={carousel[1].LinkTo}
                                ExternalLinkTo={carousel[1].ExternalLinkTo}
                                carouselData="carouselDatas"
                                id={carousel[1].id}
                            />
                        ))
                         } 
                    </div>
                    {/* <img
                        src={navigationRight}
                        alt="navigation arrow"
                        className={this.props.carouselCount+4 > totalSlides  ? styles.prevSlide : styles.prevSlideActive}
                        onClick={nextSlide}
                    /> */}

                </div>
                {/* <div className={styles.dots}>
                    {Array.from({ length: totalSlides }, (_, i) =>
                        <span key={i} className={i === this.state.currentSlideIndex ? styles.dotactive : styles.dot}
                            onClick={() => handleDotClick(i)}></span>
                    )}
                </div> */}
            </div>
        );
    }
}

export default connect(mapStateToHomeCarousel,mapDispatchToProps)(HomeCarousel);
